module.exports = __webpack_public_path__ + "static/img/14e.be6ca6b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/art/14e.jpg
// module id = UPbp
// module chunks = 0